import { Box, ClickAwayListener, Paper, Popper, styled } from '@mui/material'
import { useCallback, useState, useEffect } from 'react'
import { colorPalette } from '../../../../style/colorPalette'
import { ColumnList } from '../../../../containers/BulkSheetView/components/columnSelector/ColumnSettingPopper'
import {
  ColDef,
  ColGroupDef,
  ColumnApi,
  ColumnState,
  GridApi,
} from 'ag-grid-community'

type ColumnConfigDialogProps = {
  anchorEl: Element | undefined
  onClose: () => void
  updateConfig: (columnState: ColumnState[]) => void
  gridApi: GridApi
  columnApi: ColumnApi
  height?: number
}

export const ColumnConfigPopper = ({
  anchorEl,
  onClose,
  updateConfig,
  gridApi,
  columnApi,
  height,
}: ColumnConfigDialogProps) => {
  const [columnDefs, setColumnDefs] = useState<(ColDef | ColGroupDef)[]>(
    gridApi?.getColumnDefs() || []
  )

  const onChangeColumnVisible = useCallback(() => {
    const columnState = columnApi.getColumnState()
    updateConfig(columnState)
    setColumnDefs(gridApi.getColumnDefs() || [])
  }, [columnApi, gridApi, updateConfig, setColumnDefs])

  useEffect(() => {
    if (!gridApi) return
    setColumnDefs(gridApi.getColumnDefs() || [])
    gridApi.addEventListener('columnVisible', onChangeColumnVisible)
    return () => {
      gridApi.removeEventListener('columnVisible', onChangeColumnVisible)
    }
  }, [gridApi])

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Box>
        <Popper
          open={true}
          anchorEl={anchorEl}
          placement={'bottom'}
          disablePortal={true}
          style={{
            borderRadius: '5px',
            zIndex: 1300,
          }}
          modifiers={[{ name: 'offset', options: { offset: [120, 10] } }]}
        >
          <Paper
            style={{
              width: '320px',
              maxHeight: height ? height - 90 : 'auto',
              color: colorPalette.monotone[0],
              boxShadow: '0px 4px 16px 0px #7B8CAA80',
              boxSizing: 'border-box',
              padding: '16px',
              overflow: 'auto',
            }}
          >
            <FlexColumnContainer>
              <ColumnList
                gridApi={gridApi}
                columnApi={columnApi}
                filteredColumnDefs={columnDefs}
              />
            </FlexColumnContainer>
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  )
}

const FlexColumnContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  width: '100%',
})
